import * as yup from 'yup';

const ClinicAffiliationSchema = yup.object({
  title: yup.string().required('Name is required'),
  description: yup.string().required('Place is required'),
  avatar: yup.mixed().required('File is required'),
});

export { ClinicAffiliationSchema };
